/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-07-01 19:56:03
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-01 15:03:18
 */
import { request } from '@/utils/request'

//员工列表
export function getStaffList(params) {
  return request({
    url: '/sgsf-platform/employee/page',
    method: 'get',
    params
  })
}

// 7.2. 获取员工授权信息
export function getStaffDetail(params) {
  return request({
    url: `/sgsf-platform/employee/${params.userId}`,
    method: 'get',
    params
  })
}
// 7.4. 获取部门
export function getDepartmentList(params) {
  return request({
    url: `/sgsf-platform/employee/departments`,
    method: 'get',
    params
  })
}
// 7.3. 授予用户权限
export function setStaffRole(data, userId) {
  return request({
    url: `/sgsf-platform/employee/${userId}/grant-user-permission`,
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/sgsf-platform/sys-users/password',
    method: 'post',
    data
  })
}
// 修改密码
export function updatePassword(data, token) {
  return request({
    url: '/sgsf-agency/sysusers/password',
    method: 'put',
    headers: {
      authorization: token
    },
    data
  })
}
//
export function jyeooRefresh(data) {
  return request({
    url: `/sgsf-platform/employee/${data.userId}/grant-jyeoo-permission`,
    method: 'post',
    data
  })
}
